import * as React from 'react';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { toJS } from 'mobx'
import { SectionsConfig } from './Header';
import { getEventById } from './utils';
import { useHorsesStore } from '../../../stores/horses';
const App: React.FC<{ onChange: (value: { [key: string]: boolean }) => void }> = (props) => {
    const store = useHorsesStore()
    const [state, setState] = React.useState<{ [key: string]: boolean }>(() => {
        const arr = Object.keys(SectionsConfig)
            .map(key => {
                return { [key]: false };
            })
        return Object.assign({}, ...arr);
    });
    const [checkAll, setCheckAll] = React.useState(true)

    const isIndeterminate = React.useMemo(() => {
        const checkedItems = Object.values<boolean>(state).filter(item => item == true)

        const cnt = Object.values(state).length - checkedItems.length
        return cnt == 0 || cnt == Object.values(state).length
    }, [state]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev) => {
            const val = {
                ...state,
                [event.target.name]: event.target.checked,
            }
            props.onChange(val)
            return val
        });

    };

    const handleChangeAll = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((val) => {
            Object.keys(val).forEach(key => val[key] = event.target.checked)
            props.onChange(val)
            return { ...val }
        })

        setCheckAll(event.target.checked)
    };

    React.useEffect(() => {

        const defaultValue = Object.keys(state).reduce<{ [key: string]: boolean }>((prev, name) => {
            const existedInQueue = toJS(store.share)?.config?.find(item => {
                const eventName = getEventById({ _ID: Number(item) })
                return eventName === name
            })

            if (existedInQueue) {
                prev[name] = true

            } else {
                prev[name] = false

            }
            return prev
        }, {});
        setState({ ...defaultValue })

    }, [store.share])

    return (
        <Box sx={{ display: 'flex', margin: 0, marginTop: '16px' }}>
            <FormControl sx={{ m: 0 }} component="fieldset" variant="standard">
                <FormLabel component="legend">Share Configration</FormLabel>
                <FormGroup sx={{ flexDirection: 'row' }}>
                    {Object.keys(state).map(key => {
                        return <FormControlLabel
                            control={
                                <Checkbox checked={state[key]} onChange={handleChange} name={key} size="small" />
                            }
                            label={key}
                        />
                    })}

                    <FormControlLabel
                        control={
                            <Checkbox indeterminate={!isIndeterminate} checked={checkAll} onChange={handleChangeAll} name={'All'} size="small" />
                        }
                        label={'All'}
                    />
                </FormGroup>

                <FormHelperText>Pleas select the records you would like to share</FormHelperText>
            </FormControl>

        </Box>
    );
}
export default App
